<template>
  <v-dialog v-model="show" max-width="800">
    <v-card>
      <v-card-title class="body-1">
        Send notification
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="d-inline-flex align-center">
            <v-select
              v-model="selectedNotificationType"
              :items="['SMS', 'PUSH']"
              :label="$vuetify.lang.t('$vuetify.TYPE')"
              class="col-3 mr-2"
              outlined
              hide-details
            ></v-select>
            <v-menu v-if="selectedNotificationType === 'PUSH'" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="secondary" v-on="on">
                  {{ selectedApp }}
                </v-btn>
              </template>
              <v-list v-if="availableApplications.length">
                <v-list-item
                  v-for="(item, index) in availableApplications"
                  :key="index"
                  selected
                  @click="selectedApp = item.ShortName"
                >
                  <v-list-item-title>{{ item.ShortName }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-if="selectedNotificationType === 'PUSH'"
              v-model="title"
              :label="$vuetify.lang.t('$vuetify.TITLE')"
              outlined
            ></v-text-field>
            <v-textarea
              v-model="message"
              :label="$vuetify.lang.t('$vuetify.MESSAGE')"
              hide-details
              outlined
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="sendNotificationToClient()">
          {{ $vuetify.lang.t('$vuetify.LOGIN.SUBMIT') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'SendNotificationDialog',
  mixins: [formatDate],
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    clientId: {
      required: true,
      default: false
    }
  },
  data() {
    return {
      selectedNotificationType: 'SMS',
      selectedApp: '',
      message: '',
      title: ''
    }
  },
  computed: {
    ...mapGetters('authentication', ['user']),
    ...mapGetters('app', ['availableApplications']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  created() {
    this.getAvailableApplications().then(() => {
      this.selectedApp = 'Barking'
    })
  },
  methods: {
    ...mapActions('app', ['getAvailableApplications']),
    ...mapActions('users', ['sendNotification']),
    sendNotificationToClient() {
      this.sendNotification({
        ClientId: this.clientId,
        Type: this.selectedNotificationType,
        App: this.selectedApp,
        Title: this.title,
        Message: this.message
      })
    },
    getAppNameByAppId(id) {
      const appInAvailableApplications = this.availableApplications.find(
        app => {
          return app.ID === id
        }
      )
      return appInAvailableApplications
        ? appInAvailableApplications.ShortName
        : 'Barking'
    }
  }
}
</script>
